<div
    class="agpr-chartBlock agpr-list-chart agpr-contextMenu-parent"
    [agprLoading]="!data"
    role="region"
    tabindex="0"
    [attr.aria-label]="displayElement?.title + ' Chart. ' + ('Reports.chart.keyboardNavigationDescription' | localize)"
>
    <div
        *ngIf="preview"
        class="agpr-chartBlock-watermark"
    >
        {{ 'Reports.chart.sampleData' | localize }}
    </div>
    <div
        *ngIf="!preview"
        class="agpr-chartBlock-dragHandle"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Reports.chart.dragHandle.ariaLabel' | localize"
        (keydown)="dragKeydown($event)"
    >
        <span class="fa-kit fa-agpr-drag-drop"></span>
    </div>
    <!-- edit/delete icons -->
    <ul
        class="agpr-contextMenu top right"
        [id]="id"
        role="menu"
    >
        <li role="menuitem">
            <agpr-button
                [style]="buttonTypes.contextMenu"
                icon="fa-regular fa-duotone fa-trash-can"
                [tooltip]="'Dashboard.confirmDialog.deleteChart.button' | localize"
                (click)="doAction($event, 'delete')"
            >
            </agpr-button>
        </li>
        <li role="menuitem">
            <agpr-button
                [style]="buttonTypes.contextMenu"
                icon="fa-regular fa-duotone fa-pen"
                [tooltip]="'Dashboard.chartSettingsDialog.editChart' | localize"
                (click)="doAction($event, 'edit')"
            >
            </agpr-button>
        </li>

    </ul>
    <div
        *ngIf="displayTitle"
        class="agpr-chartBlockMetadata-title"
        [id]="id + '_title'"
    >
        <span class="{{titleIcon}} agpr-chartBlockMetadata-titleIcon"></span>
        {{ displayElement?.title }}
    </div>
    <agpr-scroll-panel
        class="agpr-list-chart-scrollPanel"
        [ngClass]="{'agpr-list-chart-scrollPanel-actionButton' : !!actionButtonLabel}"
        *ngIf="data && data.length > 0"
    >
        <div class="agpr-list-chart-scrollPanel-content">
            <ng-container *ngIf="listCardType === listCardTypesEnum.DETAIL_CARD">
                <agpr-list-detail-card
                    *ngFor="let item of data, let i = index"
                    [data]="item"
                    [id]="id + '_list_detail_' + i"
                    [small]="small"
                >
                </agpr-list-detail-card>
            </ng-container>
            <ng-container *ngIf="listCardType === listCardTypesEnum.STACKED_BAR_CARD">
                <agpr-list-stacked-bar-card
                    *ngFor="let item of data"
                    [data]="item"
                    [small]="small"
                >
                </agpr-list-stacked-bar-card>
            </ng-container>
        </div>
    </agpr-scroll-panel>
    <div
        *ngIf="actionButtonLabel && data && data.length > 0"
        class="agpr-list-chart-actionButtonWrapper"
    >
        <agpr-button
            class="agpr-list-chart-noContentActionButton"
            (click)="navigateTo()"
            [style]="buttonTypes.tertiary"
            [label]="actionButtonLabel"
        ></agpr-button>
    </div>
    <div
        class="agpr-list-chart-noContent"
        *ngIf="data && data.length === 0"
    >
        <agpr-message
            [severity]="messageSeverityEnum.noContent"
        >
            <span>
                {{ 'Dashboard.chart.noContent.placeholder.' + block?.type.key | localize }}
            </span>
        </agpr-message>
        <div
            class="agpr-list-chart-noContentAction"
        >
            <agpr-button
                class="agpr-list-chart-noContentActionButton"
                (click)="navigateTo()"
                [style]="buttonTypes.tertiary"
                [label]="'Dashboard.chart.noContent.actionButtonLabel.' + block?.type.key"
            ></agpr-button>
        </div>
    </div>

    <!-- resize icons -->
    <button
            class="gridster-item-resize gridster-item-resize--right"
            (keydown)="resizeKeydown($event)"
            [attr.aria-label]="'Dashboard.chart.resizeChart'"
        >
        <span
            class="gridster-item-icon--bottomRight fa-kit fa-agpr-resize-diagonal"
            role="img"
        ></span>
    </button>
</div>
